export function normalizeTestTabLabelsForPayload(t) {
  if (Array.isArray(t.pestanas)) {
    return t.pestanas;
  }
  if (t.pestanas) {
    return [t.pestanas];
  }
  return [];
}

function sanitizePreguntaForPayload(q) {
  if (!q || typeof q !== "object") {
    return q;
  }
  const copy = { ...q };
  delete copy.editorTabKey;
  delete copy.clientKey;
  return copy;
}

export function buildCourseTestsPayloadObject(arr) {
  const obj = {};
  const list = arr || [];
  for (let i = 0; i < list.length; i += 1) {
    const t = list[i];
    const pestanas = normalizeTestTabLabelsForPayload(t);
    const preguntas = (Array.isArray(t.preguntas) ? t.preguntas : []).map(sanitizePreguntaForPayload);
    for (let pi = 0; pi < pestanas.length; pi += 1) {
      const bloque = pestanas[pi];
      if (!bloque) {
        continue;
      }
      if (!obj[bloque]) {
        obj[bloque] = {};
      }
      const blockKeys = Object.keys(obj[bloque]);
      const temaData = {
        preguntas,
        preguntasPorIntento:
          typeof t.preguntasPorIntento === "number" && t.preguntasPorIntento > 0
            ? Math.floor(t.preguntasPorIntento)
            : null,
        tiempoPorPregunta: typeof t.tiempo === "number" ? t.tiempo * 60 : null,
        notaMinima: t.notaMinima ?? null,
      };
      let temaKey = t.titulo || `Tema ${blockKeys.length + 1}`;
      let collisionSuffix = 2;
      const labelForCollision = t.titulo || "Tema";
      while (Object.prototype.hasOwnProperty.call(obj[bloque], temaKey)) {
        temaKey = `${labelForCollision} (${collisionSuffix})`;
        collisionSuffix += 1;
      }
      obj[bloque][temaKey] = temaData;
    }
  }
  return obj;
}
